import {
  Component, ViewChild, ChangeDetectorRef, ElementRef,
  ViewEncapsulation, ChangeDetectionStrategy, OnInit, OnDestroy
} from '@angular/core';
import { ComponentDefinition } from '@formbird/types';
import { AbstractComponent, ComponentSetupService } from '@formbird/angular-shared';
import { MatSliderChange } from '@angular/material/slider';
import AceDiff from 'ace-diff';
import * as ace from 'ace-builds/src-min-noconflict/ace';
import 'ace-builds/src-min-noconflict/ace';
import 'ace-builds/src-min-noconflict/mode-json';
import 'ace-builds/src-min-noconflict/theme-monokai';
import * as $ from 'jquery';

const injector = (<any>window).FormbirdServiceInjector;
const changedDocumentService = injector.get('ChangedDocumentService');

interface AuditHistoryComponentDefinition extends ComponentDefinition {
}

function sortJsonAlphabetically(jsonData) {
  if (Array.isArray(jsonData)) {
      return jsonData.map(sortJsonAlphabetically);
  } else if (jsonData !== null && typeof jsonData === 'object') {
      const sortedObject = {};
      Object.keys(jsonData).sort().forEach((key) => {
          sortedObject[key] = sortJsonAlphabetically(jsonData[key]);
      });
      return sortedObject;
  } else {
      return jsonData;
  }
}

@Component({
  templateUrl: './audit-history.component.html',
  styleUrls: ['./audit-history.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ScAuditHistoryComponent extends AbstractComponent<AuditHistoryComponentDefinition> implements OnInit, OnDestroy {

  id: any;
  numberOfVersions: number = 1;
  previousHTML: any;
  cbxVersionOne: any = '';
  cbxVersionTwo: any = '';
  versionIds: any = [];
  versions: any = [];
  basicValue: number = 0;
  min: number = 0;
  max: number = 0;
  isLoading: boolean;
  error: string | null;
  sub: any;
  differ: any;

  auditService: any;

  toDownloadOne = '';
  toDownloadTwo = '';

  sortFields: boolean = false;

  @ViewChild('diffView', { static: true })
  diffView: ElementRef;

  constructor(
    protected changeDetectorRef: ChangeDetectorRef,
    public element: ElementRef,
    componentSetupService: ComponentSetupService
  ) {
    super(injector, changedDocumentService, componentSetupService, changeDetectorRef);
    this.auditService = injector.get("AuditService");
  }



  async displayDiff(objDataDiff: any) {
    const [baseDoc, newDoc, versionOne, versionTwo] = objDataDiff;
    const formatDoc = (doc: any) => JSON.stringify(
      this.sortFields ? sortJsonAlphabetically(doc) : doc, null, 4)
      .replace(/\\\\t/g, '\t')
      .replace(/\\\\n/g, '\n')
      .replace(/\\n/g, '\n')
      .replace(/\\t/g, '\t');
    

    this.differ = new AceDiff({
        element: this.diffView.nativeElement,
        mode: 'ace/mode/json',
        left: {
            content: formatDoc(baseDoc),
            copyLinkEnabled: false,
            editable: false
        },
        right: {
            content: formatDoc(newDoc),
            copyLinkEnabled: false,
            editable: false
        }
    });
    
    ace.config.set('basePath', 'https://cdnjs.cloudflare.com/ajax/libs/ace/1.4.12/');

    var left = this.differ.editors.left.ace
    var right = this.differ.editors.right.ace

    $('.acediff__left .ace_scrollbar-v').scroll(() =>
        right.session.setScrollTop(left.session.getScrollTop()))
    $('.acediff__right .ace_scrollbar-v').scroll(() =>
        left.session.setScrollTop(right.session.getScrollTop()))

    this.isLoading = false;
    this.toDownloadOne = JSON.stringify(baseDoc);
    this.toDownloadTwo = JSON.stringify(newDoc);
    this.cbxVersionOne = versionOne;
    this.cbxVersionTwo = versionTwo;
  }

  async getObjProcessDataDiff(index: number, max: number, versions: any, versionIds: any) {
    const processDataDiffResult = await this.auditService.processDataDiff(index, max, versions, versionIds);
    return processDataDiffResult;
  }

  async callDisplayDiff(objDataDiff: any) {
    if (!objDataDiff) {
      this.isLoading = false;
      return;
    }

    await this.displayDiff(objDataDiff);

    this.cbxVersionOne = objDataDiff[2];
    this.cbxVersionTwo = objDataDiff[3];

    this.changeDetectorRef.detectChanges();
  }

  async display() {
    if (!this.versionIds || !this.versions) {
      return;
    }

    const versionOne = this.cbxVersionOne;
    const versionTwo = this.cbxVersionTwo;
    const fetchResult = await this.auditService.fetch(this.versions, versionOne, versionTwo);
    return await this.callDisplayDiff(fetchResult);
  }

  override ngOnInit() {
    super.ngOnInit();
    this.isLoading = true;
    const url = window.location.href;
    const id = url.split("/")[4];

    if (id) {
      this.id = id;
      this.error = null;

      this.auditService
        .getVersions(this.id)
        .then((results: any) => {
          if (results && results.length) {
            this.numberOfVersions = results.length;
            this.versionIds = results;
            this.max = results.length - 1;

            this.getObjProcessDataDiff(0,
              this.max, this.versions, this.versionIds).then(result =>
                this.callDisplayDiff(result)
              );

            this.changeDetectorRef.detectChanges();
          } else {
            this.isLoading = false;
            this.error = `Document ${this.id} doesn't exist.`;
          }
        }).catch((error: any) => {
          console.log(error);
        });
    }
  }

  override ngOnDestroy() {
    super.ngOnDestroy();
    this.sub.unsubscribe();
  }

  formatVersionId({ versionId, createdDate }: any) {
    return this.auditService.formatVersionId({ systemHeader: { versionId, createdDate } });
  }

  onCheckboxChange(event: any): void {
    this.sortFields = event.checked;
    this.display();
  }
  
  onInputChange(event: MatSliderChange) {
    const index = event.value || 0;
    this.basicValue = index;
    return this.getObjProcessDataDiff(index, this.max, this.versions, this.versionIds).then(result =>
      this.callDisplayDiff(result)
    );
  }

  openVersion(versionId) {
    window.open('/form/' + versionId, '_blank');
  }

}
